<template lang="pug">
  .component.component-backoffice-driver.driver(v-if="item")
    .card(v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="5")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              driver-action-buttons(:driver="item")
          div.small-6(slot="n1")
            thumbnail(:image="item.profile_picture")
          driver-fields(slot="n2", :item="item", :fieldName="'driver-info'")
          driver-fields(slot="n3", :item="item", :fieldName="'city'")
          driver-fields(slot="n4", :item="item", :fieldName="'created'")
          driver-fields(slot="n5", :item="item", :fieldName="'phone-and-email'")
          div(slot="actionPage")
            router-link(:to="{name:'driver', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
          DriverNotification(:driver_id="item.id")
    .card(v-if="$is('pendingDelete')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="5")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              driver-action-buttons(:driver="item", :pending-delete="true")
          div.small-6(slot="n1")
            thumbnail(:image="item.profile_picture")
          driver-fields(slot="n2", :item="item", :fieldName="'driver-info'")
          driver-fields(slot="n3", :item="item", :fieldName="'city'")
          driver-fields(slot="n4", :item="item", :fieldName="'created'")
          driver-fields(slot="n5", :item="item", :fieldName="'phone-and-email'")
          div(slot="actionPage")
            router-link(:to="{name:'driver', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .card(v-if="$is('approvalListing')")
      .inner-content
        .columns
          .row
            .columns.shrink.align-self-middle
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                driver-action-buttons(:driver="item")
            .columns
              .row
                .columns.small-1.align-self-middle.thumb-container
                  thumbnail(:image="item.profile_picture")
                .columns.n2.align-self-middle
                  driver-fields(slot="n2", :item="item", :fieldName="'driver-info-no-status'")
                  driver-fields(slot="n5", :item="item", :fieldName="'phone-and-email'")
                .columns.small-6.align-self-middle.text-center
                  AccountStatus(:statuses="['client', 'address','subscription','document_status']", :accountStatus="accountStatus")
                .columns.shrink.n4.align-self-middle
                  driver-fields(slot="n5", :item="item", :fieldName="'created'")
                  driver-fields(slot="n5", :item="item", :fieldName="'updated'")
            .columns.shrink.align-self-middle
              router-link(:to="{name:'driver', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-3x.action
    .onlyname(v-if="$is('onlyname')")
      //driver-fields(:item="item", :fieldName="'driver-info'")
      driver-fields(:item="item", :fieldName="'driver-fullname'")

    .onelook(v-if="$is('oneLook')")
      driver-fields(slot="n1", :item="item", :fieldName="'driver-info'")
    .card(v-if="$is('driver-card')")
      .driver-card.inner-content
        .row.collapse.align-middle
          .columns.shrink
            thumbnail(:image="item.profile_picture")
          .columns.small-offset-1
            .driver
              router-link(:to="{name:'driver', params:{id:item.id}}" )
                span {{item.name}} {{item.surname}} (DR{{item.id}})
            .client
              router-link(:to="{name:'client', params:{id:item.client_id}}" )
                span {{item.client_organization_name}} (CL{{item.client_id}})
        .row
          .columns.shrink(v-if="fakePicture")
            a.m-1(v-on:click="openPicture(item.profile_picture_original)" ).fa.fa-search-plus.large.fa-lg
            a.m-1(v-on:click="deletePicture").fa.fa-trash.large.fa-lg
            ModalReveal(ref="reveal")
              img(:src='pictureOriginal' width="90%")
        .row.align-right.align-middle
          a.pr-2(v-if="item.mobile", :href="'https://wa.me/'+item.mobile.replace('-','').replace('+', '')", target="_blank").fa.fa-comments.fa-lg
          a.pr-2(v-if="item.mobile", :href="'tel:'+item.mobile").fa.fa-phone.fa-lg
          CallButton(v-if="this.c2cEnabled && item.mobile", :phone="item.mobile")
          a.pr-2(v-if="item.email", :href="'mailto:'+item.email").fa.fa-envelope.fa-lg
          DriverNotes(:driver_id="item.id" :type="'noteCard'")
          DriverNotification(:driver_id="item.id")
          DriverPass(:driver_id="item.id")
    .card(v-if="$is('driver-card-approval')")
      .driver-card.inner-content

        CardN(:columns="12")
          thumbnail(slot="n1", :image="item.profile_picture")
          driver-fields(slot="n2", :item="item", :fieldName="'driver-info'")
      //.driver-card.inner-content
          .row
            .columns.small-3
              thumbnail(:image="item.profile_picture")
            .columns.small-9
              .driver
                router-link(:to="{name:'driver', params:{id:item.id}}" )
                  span {{item.name}} {{item.surname}}
    .inner-content(v-if="$is('driver-data')")
      simple-columns33
        .field.field-first-name(slot="n1")
          .label First Name
          .field-value {{item.name}}
        .field-last-name(slot="n2")
          .label Last name
          .field-value {{item.surname}}
        .field-birthday(slot="n3")
          .label Date Of Birth
          .field-value {{$dateFormat(item.birthdate, 'DD MMMM YYYY')}}
        .field-gender(slot="n4")
          .label Gender
          .field-value {{item.gender}}
        .field-country(slot="n5")
          .label Country
          .field-value {{item.address.country}}
        .field-address(slot="n6")
          .label Address
          .address {{item.address.street}} {{item.address.city}} {{item.address.country}}
          .postal-code {{item.address.postal_code}}

      simple-columns33
        .field-username(slot="n1")
          .label Username
          .field-value {{item.username}}
        .field-member-id(slot="n2")
          .label Member Id
          .field-value {{item.id}} - {{item.uid}}
        .field-created(slot="n3")
          .label Member Since
          .field-value {{$dateFormat(item.created, 'DD MMMM YYYY')}}
        .field-status(slot="n4")
          .label Status
          .field-value {{item.status}}
      simple-columns33
        div(slot="n1")
          .label Created
          driver-fields(:item="item", :fieldName="'created'")
        div(slot="n2")
          .label Updated
          driver-fields(:item="item", :fieldName="'updated'")
      simple-columns33
        .field-email(slot="n1")
          .label Email
          .field-value {{item.email}}
        .field-phone(slot="n2")
          .label Phone
          .field-value {{item.phone}}
        .field-mobile(slot="n3")
          .label Mobile
          .field-value {{item.mobile}}

      template(v-if="item.extra && item.extra['app-version']")
        hr
        .row
          .column
            .label App version
            .field-value {{item.extra['app-version']}}
        .row
          .column.large-4.small-6(v-for="(extra,key,index) in item.extra.device", :slot="`n`+index")
            .label {{key}}
            .field-value {{extra}}
    .client-drivers(v-if="$is('client-drivers')")
      .card
        .inner-content
          card10(:showBullets="true")

            driver-fields(slot="n1", :item="item", :fieldName="'driver-id'")
            driver-fields(slot="n1", :item="item", :fieldName="'driver-uid'")
            driver-fields(slot="n2", :item="item", :fieldName="'driver-name'")
            driver-fields(slot="n3", :item="item", :fieldName="'driver-surname'")
            driver-fields(slot="n4", :item="item", :fieldName="'driver-gender'")
            driver-fields(slot="n5", :item="item", :fieldName="'driver-country'")
            driver-fields(slot="n6", :item="item", :fieldName="'city'")
            driver-fields(slot="n7", :item="item", :fieldName="'driver-status'")
            driver-fields(slot="n8", :item="item", :fieldName="'created'")
            driver-fields(slot="n9", :item="item", :fieldName="'updated'")
            div(slot="actionBullets")
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                driver-action-buttons(:driver="item")
    .group-drivers(v-if="$is('groupList')")
      .label Driver
      .field-value D{{item.id}} {{item.name}} {{item.surname}}
    .card(v-if="(item.status ==='SUSPENDED' || item.status ==='ON HOLD') && type === 'highlightedNotes'")
      DriverNotes(:driver_id="item.id" :type="'highlightedNotes'" @notes="retriveLastNotes")
      .row.column.pl-2.pr-2.pt-2.pb-2
        .label last two notes {{type}}
        .row.column.small-12( v-for ="(lastNote,key) in lastNotes") {{ lastNote }}
</template>

<script type="text/babel">
import Accordion from '../../components/structure/foundation/Accordion.vue'
import Status from 'components/structure/ui/Status'
import CardN from 'components/structure/CardN'
import Dropdown from 'components/structure/foundation/Dropdown'
import DriverActionButtons from 'components/structure/ui/actions/DriverActionButtons'
import Card6 from '../structure/Card6'
import DriverFields from '../structure/ui/entity-fields/DriverFields.vue'
import Card10 from '../structure/Card10.vue'
import SimpleColumns33 from '../structure/simpleColums3-3.vue'
import thumbnail from '../structure/thumbnail'
import AccountStatus from './AccountStatus'
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import MaggieHelper from "../../maggieHelper";
import ModalReveal from "../structure/foundation/ModalReveal";
import DriverNotes from "./DriverNote";
import CallButton from "./CallButton";
import DriverNotification from "./DriverNotification.vue";
import MdiIcon from "../structure/ui/MdiIcon.vue";
import ManageDriverPass from "./ManageDriverPass.vue";

export default {
  name: 'BackofficeDriver',
  data() {
    return {
      fakePicture: false,
      pictureOriginal: '',
      lastNotes: [],
    }
  },
  components: {
    DriverPass: ManageDriverPass,
    MdiIcon,
    CallButton,
    DriverNotes,
    ModalReveal,
    AccountStatus,
    thumbnail,
    SimpleColumns33,
    Card10,
    DriverFields,
    Card6,
    Accordion,
    Status,
    CardN,
    Dropdown,
    DriverActionButtons,
    DriverNotification

  },
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.lookForDeletableProfilePicture()
  },
  created() {
  },
  methods: {
    retriveLastNotes(items) {
      var count = 0
      self = this
      items.items.forEach( function (item){
        if(count<2) {
          self.lastNotes.push(item.description)
          count++
        }
      })
    },
    update: function () {
      this.$emit('updated', this.item)
    },
    lookForDeletableProfilePicture() {
      if (this.item.profile_picture.indexOf('/res') > -1) {
        return this.fakePicture = false
      }
      return this.fakePicture = true
    },
    deletePicture() {
      this.$confirm('Are you sure', `Do you want to delete profile picture?`, () => {
        KeplerBackofficeSdk.drivers.select(this.item).pictureDelete((data) => {
            if (data.result_code == 'profile-picture-deleted') {
              MaggieHelper.notification('delete-esit', data.result)
              window.location.reload()
            } else {
              MaggieHelper.notification('delete-esit', data.result)
            }
          }
        )
      })
    },

    openPicture(po) {
      this.pictureOriginal = po
      this.$refs.reveal.openModal()
    }
  },
  computed: {
    accountStatus() {
      let accountStatus = this.item.account_status
      accountStatus.address = !!this.item.address.street
      return accountStatus
    },
    c2cEnabled: function () {
      return window.env.C2C_ENABLED == 'true'
    },
  }
}
</script>
<style lang="sass">
.component-backoffice-driver
  p, img
    margin-bottom: 0

  .thumb-container
    min-width: 4em

  .activeIcon
    color: #64db6f
</style>>



// WEBPACK FOOTER //
// Driver.vue?543ec43d